import React, { useState, useEffect } from "react";
import Layout from "../../Layout";
import Container from "../../components/Container";
import List from "../../components/List";
import Modal from "../../components/Modals/Modal";
import { Button, Input } from "../../components/Form";
import { FaSave } from "react-icons/fa";
import { MdAdd } from "react-icons/md";
import { useAppSelector } from '../../store';

import { getAllLabProductExtras, createLabProductExtra } from "../../api/labProductExtra";
import { toast } from 'react-toastify';
import Loader from "../../components/Loader";

function ProductExtras() {
	const userData = useAppSelector((state) => state.userData);

	const [modal, setModal] = useState(false);
	const [productExtras, setProductExtras] = useState([]);
	const [name, setName] = useState("");
	const [price, setPrice] = useState("");
	const [loading, setLoading] = useState(false);
	const [pageLoader, setPageLoader] = useState(true);

	useEffect(() => {
		console.log(userData)
		const fetchData = async () => {
			const res = await getAllLabProductExtras({ labId: userData?.user?.defaultLabId });
			setProductExtras(res);
			setPageLoader(false);
			console.log(res);
		};

		if (userData?.user?.defaultLabId) {
			fetchData();
		} else {
			setPageLoader(false);
		}
	}, [userData, modal]);

	const handleSave = async () => {
		if (!name.trim()) {
			toast.error("Name is required");
			return;
		}

		const data = {
			labId: userData?.user?.defaultLabId,
			name: name,
			price: price || 0,
		};

		setLoading(true);
		const response = await createLabProductExtra(data);
		if (response) {
			setLoading(false);
			setModal(false);
			setName("");
			setPrice("");
		}
		setLoading(false);
	}

	return (
		<Layout>
			{
				pageLoader ? <Loader /> :
					<>
						{
							productExtras.length === 0 ?
								<div className="text-center text-lg my-4">No Product Extras</div>
								:
								<Container className={"flex flex-1 flex-col divide-y rounded-xl "}>
									<List list={productExtras} path={"extras"} />
								</Container>
						}
						<div className="flex justify-center items-center my-2">
							<Button
								className={"w-52 max-w-fit px-5"}
								label={"Add New Product Extra"}
								Icon={() => <MdAdd size={22} />}
								onClick={() => setModal(true)}
							/>
						</div>
						<Modal isOpen={modal} closeModal={() => setModal(false)} title={"Add Products"}>
							<Input label={"Name *"} placeholder={"Metal ceramic, Zirconia, ..."} color={true} value={name} onChange={(e) => setName(e.target.value)} />
							<Input label={"Price (BAM)"} placeholder={"Price"} color={true} type={"number"} min={0} value={price} onChange={(e) => setPrice(e.target.value)} />
							<Button className={"my-4"} label={"Save"} Icon={FaSave} onClick={handleSave} loading={loading} />
						</Modal>
					</>
			}
		</Layout>
	);
}

export default ProductExtras;
